import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [

  {
    path: '/',
    name: 'layout',
    component: () => import(/* webpackChunkName: "layout" */ '@/layout/index.vue'),
    redirect: '/login',

    children: [
      {
        name: 'home',
        path: '/home',
        meta: { title: '天联管理后台-首页' },
        component: () => import(/* webpackChunkName: "home" */ '@/views/home/index.vue')
      },
      {
        name: 'userManagement',
        path: '/userManagement',
        meta: { title: '天联管理后台-用户管理' },
        component: () => import(/* webpackChunkName: "userManagement" */ '@/views/home/userManagement.vue')
      },
      {
        name: 'logCenter',
        path: '/logCenter',
        meta: { title: '天联管理后台-操作日志' },
        component: () => import(/* webpackChunkName: "logCenter" */ '@/views/home/logCenter.vue')
      },
      {
        name: 'applicationPush',
        path: '/applicationPush',
        meta: { title: '天联管理后台-应用发布' },
        component: () => import(/* webpackChunkName: "applicationPush" */ '@/views/home/applicationPush.vue')
      },
      {
        name: 'helpDocument',
        path: '/helpDocument',
        meta: { title: '天联管理后台-帮助文档' },
        component: () => import(/* webpackChunkName: "helpDocument" */ '@/views/home/helpDocument.vue')
      },
      {
        name: 'passRouting',
        path: '/passRouting',
        meta: { title: '天联管理后台-旁路由' },
        component: () => import(/* webpackChunkName: "helpDocument" */ '@/views/passRouting/passRouting.vue')
      },
      {
        name: 'networkLine',
        path: '/networkLine',
        meta: { title: '天联管理后台-组网线路' },
        component: () => import(/* webpackChunkName: "networkLine" */ '@/views/networkLine/networkLine.vue')
      },
      {
        name: 'accessPolicy',
        path: '/accessPolicy',
        meta: { title: '天联管理后台-访问策略', wgRequired: true },
        component: () => import(/* webpackChunkName: "accessPolicy" */ '@/views/wg/accessPolicy.vue')
      },
      {
        name: 'accessMatrix',
        path: '/accessMatrix',
        meta: { title: '天联管理后台-访问矩阵', wgRequired: true },
        component: () => import(/* webpackChunkName: "accessMatrix" */ '@/views/wg/accessMatrix.vue')
      },
      {
        name: 'tagManagement',
        path: '/tagManagement',
        meta: { title: '天联管理后台-标签管理', wgRequired: true },
        component: () => import(/* webpackChunkName: "tagManagement" */ '@/views/wg/tagManagement.vue')
      },
      {
        name: 'networkTopology',
        path: '/security/networkTopology',
        meta: { title: '天联管理后台-组网类型', wgRequired: true },
        component: () => import(/* webpackChunkName: "networkTopology" */ '@/views/security/networkTopology.vue')
      }

    ]
  },
  {
    path: '/login',
    name: 'login',
    meta: { title: '天联管理后台-登录' },
    component: () => import(/* webpackChunkName: "login" */ '@/views/login/index.vue')
  },
  {
    path: '/register',
    name: 'register',
    meta: { title: '天联管理后台-注册' },
    component: () => import(/* webpackChunkName: "register" */ '@/views/register/index.vue')
  },
  {
    path: '/password',
    name: 'password',
    meta: { title: '天联管理后台-忘记密码' },
    component: () => import(/* webpackChunkName: "password" */ '@/views/password/index.vue')
  }
]

const router = createRouter({
  // history: createWebHistory(),
  history: createWebHashHistory(),
  routes
})

// 登录态白名单：这些路由无需 token 即可访问
const WHITE_LIST = ['/login', '/register', '/password']

router.beforeEach((to, from, next) => {
  window.document.title = to.meta.title
  if (to.path) {
    if (window._hmt) {
      window._hmt.push(['_trackPageview', '/#' + to.fullPath])
    }
  }

  // 登录态校验：非白名单路由无 token 则跳登录页，确保 layout 仅在登录态挂载
  // （connectReloginSse 在 layout setup 中发起，此时 token 必在，杜绝空 Bearer）
  if (!WHITE_LIST.includes(to.path) && !localStorage.getItem('token')) {
    next({ path: '/login' })
    return
  }

  // ACL（WG 组）页面级拦截：仅在 is_wg_group=1 的组可访问带 meta.wgRequired 的路由。
  // /accessPolicy 与 /tagManagement 已加 wgRequired meta；非 WG 组点击菜单看不到入口，
  // 即便直接访问 URL 也会被重定向回 /home。
  if (to.meta && to.meta.wgRequired) {
    const isWgGroup = localStorage.getItem('is_wg_group')
    if (isWgGroup !== '1') {
      // 非 WG 组禁止进入 ACL 相关页面，回退首页
      next({ path: '/home' })
      return
    }
  }

  next()
})
export default router
